import { fetchApi } from '@/config/axiosSetting';
import {
  GetOtherCostsQueryResponseType,
  IGetOtherCostsQueryParams,
} from './getOtherCostsQuery.types';

export const getOtherCostsFunction = (
  params: IGetOtherCostsQueryParams,
): Promise<GetOtherCostsQueryResponseType> => {
  return fetchApi.get(
    `property/reports/${params.id}/accident_users/other_damaged/adjusting/costs/`,
    { params },
  );
};
